module.exports = __webpack_public_path__ + "static/media/loader_white.03dcadef.svg";